import { IN_APP_HELP_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { useEffect, useRef } from 'react';
const getWidgetPath = options => {
  options = options || {};
  if (options.create) {
    return `create?autoOpened=${!!options.autoOpened}`;
  }
  if (options.migrationId) {
    return `migration?migrationId=${options.migrationId}`;
  }
  if (options.feedback) {
    return 'feedback';
  }
  if (options.url || options.kbArticle) {
    return `url?location=${decodeURIComponent(options.url || options.kbArticle || '')}`;
  }
  if (options.chat) {
    return 'chat';
  }
  if (options.isc) {
    return 'isc-chat';
  }
  const {
    segments
  } = options;
  if (segments) {
    return typeof segments === 'string' ? `segments/${segments}` : 'segments';
  }
  if (options.reopened) {
    return '?reopened=true';
  }
  return '';
};
export const useAddZorseFunctions = ({
  toggleHelpWidget,
  navComponent = IN_APP_HELP_COMPONENT
}) => {
  const {
    onToggle
  } = useToggleComponent(navComponent);
  const callbacks = useRef([]);
  useEffect(() => {
    const unsubscribe = onToggle(open => {
      callbacks.current.forEach(callback => callback(open));
    });
    return () => {
      unsubscribe();
    };
  }, [onToggle]);
  useEffect(() => {
    if (!window.hubspot) {
      return;
    }
    const hubspotWindow = window.hubspot;
    hubspotWindow.zorse = hubspotWindow.zorse || {};
    hubspotWindow.zorse.openHelpWidget = options => {
      const path = getWidgetPath(options);
      toggleHelpWidget({
        shouldOpen: true,
        route: path
      });
    };
    hubspotWindow.zorse.closeHelpWidget = () => {
      toggleHelpWidget({
        shouldOpen: false
      });
    };
    hubspotWindow.zorse.minimizeZorseWidgetButton = () => {
      toggleHelpWidget({
        shouldOpen: false
      });
    };
    hubspotWindow.zorse.restoreZorseWidgetButton = () => {
      toggleHelpWidget({
        shouldOpen: true
      });
    };
    hubspotWindow.zorse.onOpenCloseWidget = callback => {
      if (typeof callback !== 'function') {
        return false;
      }
      for (const cb of callbacks.current) {
        if (cb === callback) {
          return false;
        }
      }
      callbacks.current.push(callback);
      return true;
    };
    return () => {
      hubspotWindow.zorse = hubspotWindow.zorse || {};
      hubspotWindow.zorse.openHelpWidget = undefined;
      hubspotWindow.zorse.closeHelpWidget = undefined;
      hubspotWindow.zorse.minimizeZorseWidgetButton = undefined;
      hubspotWindow.zorse.restoreZorseWidgetButton = undefined;
      hubspotWindow.zorse.onOpenCloseWidget = undefined;
    };
  }, [navComponent, toggleHelpWidget]);
};